export const CHANGE_PROGRESS = 'CHANGE_PROGRESS_ONBOARD_US';
export const NEXT_STEP = 'NEXT_STEP_ONBOARD_US';
export const PREV_STEP = 'PREV_STEP_ONBOARD_US';
export const SET_VALUE_STEP00 = 'SET_VALUE_STEP00_ONBOARD_US';
export const SET_VALUE_STEP01 = 'SET_VALUE_STEP01_ONBOARD_US';
export const SET_VALUE_STEP01_BUSINESS = 'SET_VALUE_STEP01_ONBOARD_BUSINESS_US';
export const SET_VALUE_STEP02 = 'SET_VALUE_STEP02_ONBOARD_US';
export const SET_VALUE_STEP03 = 'SET_VALUE_STEP03_ONBOARD_US';
export const SET_VALUE_STEP04 = 'SET_VALUE_STEP04_ONBOARD_US';
export const SET_VALUE_STEP05 = 'SET_VALUE_STEP05_ONBOARD_US';
export const SET_VALUE_STEP06 = 'SET_VALUE_STEP06_ONBOARD_US';

export const SEARCH_COMPANY_NAME = 'SEARCH_COMPANY_NAME_US';
export const SET_STEP01_KEYWORD = 'SET_STEP01_KEYWORD_US';
export const SET_COMPANIES_FOUND_VIA_NAME = 'SET_COMPANIES_FOUND_VIA_NAME_US';
export const SET_REGISTER_FORM = 'SET_REGISTER_FORM_US';

export const SET_IPINFO = 'SET_IPINFO_US';
export const SET_PAY_PROVIDER = 'SET_PAY_PROVIDER_US';
export const SET_THREATMETRIX_SESSION_ID = 'SET_THREATMETRIX_SESSION_ID';
